import '@calcom/atoms/globals.min.css';
import * as React from 'react';
import { BackgroundGradient } from '@epihub/web/src/tailwind/components/BackgroundGradient';
import { useItemCallback } from '@epihub/web/src/hooks/useItemCallback';
import { styled } from '../../theme/theme';

type Props = {
  eventSlug: string;
  eventData: { title: string; description: string; duration: string };
  isSelected: boolean;
  onClick: (es: string) => void;
};

export const CalendarEventCard = ({ eventSlug, eventData, isSelected, onClick }: Props) => {
  const handleClick = useItemCallback(eventSlug, onClick);
  return (
    <CardWrapper onClick={handleClick}>
      <BackgroundGradient
        showBorder={isSelected}
        containerClassName='w-full'
        className='rounded-[22px] bg-white dark:bg-zinc-900 h-full'
      >
        <CardContent>
          <CardTitle className='text-black dark:text-neutral-200'>
            {eventData.title}
          </CardTitle>
          <CardDescription className='text-neutral-600 dark:text-neutral-400'>
            {eventData.description}
          </CardDescription>
          <DurationBadge
            className='text-white bg-black dark:bg-zinc-800'
            disabled
            type='button'
          >
            <span>{eventData.duration}</span>
          </DurationBadge>
        </CardContent>
      </BackgroundGradient>
    </CardWrapper>
  );
};

const CardWrapper = styled.div`
  display: flex;
  width: 100%;

  @media (min-width: 769px) {
    flex: 1;
    min-width: 0;
  }
  :active {
    transform: scale(0.98);
  }
  cursor: pointer;
`;

const CardContent = styled.div`
  padding: 16px 30px;

  @media (min-width: 640px) {
    padding: 16px 30px;
  }
`;

const CardTitle = styled.h3`
  font-size: 1.5rem;
  font-weight: 700;
  margin-top: 16px;
  margin-bottom: 8px;
`;

const CardDescription = styled.p``;

const DurationBadge = styled.button`
  border-radius: 9999px;
  padding: 4px 16px;
  display: flex;
  align-items: center;
  gap: 4px;
  margin-top: 16px;
  margin-left: auto;
  font-size: 0.75rem;
  font-weight: 700;
  pointer-events: none;
  cursor: default;
`;
